import { AppPaths } from "@p0security/shared/routes/constants";
import { Outlet, Route } from "react-router-dom";

import { Page } from "../App/Page.tsx";
import { JIT_ROUTING_ROLES } from "../App/roles.ts";
import { AuthzGuard } from "../Login/index.tsx";
import { Vault } from "./Vault.tsx";

export const VaultRoutes = (
  <Route path={AppPaths.Vault}>
    <Route
      element={
        <AuthzGuard requirement={JIT_ROUTING_ROLES}>
          <Page title="Vault">
            <Outlet />
          </Page>
        </AuthzGuard>
      }
    >
      <Route index element={<Vault />} />
      <Route path=":id" element={<Vault />} />
    </Route>
  </Route>
);
